import styles from './Callback.module.css';
import { useCallback } from './Callback.hooks';

import { Loading } from '../../../components/loading/Loading';
import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

export const Callback = () => {
	// const navigate = useNavigate();
	const { isLoading, error } = useCallback();
	useEffect(() => {
		if (isLoading) {
			return;
		}
		if (!error) {
			// navigate('/');
			location.href = '/';
		}
	}, [isLoading]);
	if (error) {
		return <div className={styles['error']}>{error.message}</div>;
	}
	return (
		<div className={styles['loading']}>
			<Loading />
		</div>
	);
};
